import React from "react";
import config from "../config";

import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";
import UserUtil from "../utils/UserUtil";

class ApiSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      public: {},
      secret: {}
    };
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {
    UserUtil.makeApiKey(this.props.apiKey, {
      scope: "user-public",
      allow_existing: true,
      god_become_user: UserStore.isGod()
        ? UserStore.getGodCredentials().activeUser
        : undefined
    }).then(k => this.setState({ public: k }));
    UserUtil.makeApiKey(this.props.apiKey, {
      scope: "user-secret",
      allow_existing: true,
      god_become_user: UserStore.isGod()
        ? UserStore.getGodCredentials().activeUser
        : undefined
    }).then(k => this.setState({ secret: k }));
  }

  generate(scope) {
    if (
      window.confirm(
        `Are you sure? All existing ${scope} keys will stop working immediately and must be replaced with the new key.`
      )
    ) {
      let oldKey = this.state[scope].key;
      this.setState({ [scope]: {} });

      UserUtil.deleteApiKey(this.props.apiKey, oldKey)
        .then(() =>
          UserUtil.makeApiKey(this.props.apiKey, {
            scope: `user-${scope}`,
            allow_existing: true,
            god_become_user: UserStore.isGod()
              ? UserStore.getGodCredentials().activeUser
              : undefined
          })
        )
        .then(k => this.setState({ [scope]: k }));
    }
  }

  getStyles() {
    return {
      key: { margin: "0.5em 0 0" }
    };
  }

  render() {
    const styles = this.getStyles();

    if (!this.props.apiKey) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <p>
          The Eventive API allows you to build a fully custom Eventive
          experience, from backend to frontend to mobile.
          <br />
          <a
            href="https://help.eventive.org/integrations/eventive-api"
            target="_blank"
          >
            Learn more about the Eventive API.
          </a>
        </p>
        <h2>API keys for {this.props.data.owner.organization}</h2>
        <h3 style={styles.key}>
          Public API key:{" "}
          <code>{this.state.public.key || "...loading..."}</code>
        </h3>
        <div>
          Include in customer-accessible pages (e.g. in client-side JavaScript).
          For read-only access to events/films, new order flow, etc.
        </div>
        <div>
          <small>
            Generated: {this.state.public.created_at || "...loading..."}{" "}
            {this.state.public.key ? (
              <span>
                |{" "}
                <a href="#" onClick={this.generate.bind(this, "public")}>
                  Invalidate & generate new key
                </a>
              </span>
            ) : null}
          </small>
        </div>
        <h3 style={styles.key}>
          Secret API key:{" "}
          <code>{this.state.secret.key || "...loading..."}</code>
        </h3>
        <div>
          For your backend only. Full read & write access to the Eventive
          Platform. Never expose to customers.
        </div>
        <div>
          <small>
            Generated: {this.state.secret.created_at || "...loading..."}{" "}
            {this.state.secret.key ? (
              <span>
                |{" "}
                <a href="#" onClick={this.generate.bind(this, "secret")}>
                  Invalidate & generate new key
                </a>
              </span>
            ) : null}
          </small>
        </div>
      </div>
    );
  }
}

export default connectToStores(ApiSetup);



// WEBPACK FOOTER //
// ./src/app/components/api-setup.jsx